import { init, showReportDialog } from '@sentry/browser';

window.ErrorReporting = { showReportDialog };

// Runtime configuration lets the same assets serve Flower and Eagle.
if (window.hostvars?.sentry_pdsn) {
    init({
        dsn: hostvars.sentry_pdsn,
        release: hostvars.sentry_release || undefined,
        environment: hostvars.sentry_environment,
        // GlitchTip 5.1 does not ingest Sentry sessions or client reports.
        integrations: defaults => defaults.filter(integration => integration.name !== 'BrowserSession'),
        sendClientReports: false,
        sendDefaultPii: false,
        denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i, /^safari(-web)?-extension:\/\//i],
        ignoreErrors: [
            /^Can't find variable: __firefox__$/,
            /^undefined is not an object \(evaluating 'window\.__firefox__\.reader'\)$/,
            /^undefined is not an object \(evaluating 'window\.ethereum\.selectedAddress = undefined'\)$/,
        ],
    });
}
